import * as React from 'react'

import { 
  EVIDENCE_HIGHLIGHT, 
  EVIDENCE_STEP_FIRST_ATTEMPT, 
  EVIDENCE_STEP_WITH_FEEDBACK, 
  FOUNTAIN_PEN_ICON 
} from '../asset_constants'

const WhatIsReadingForEvidence = ({ slideGroupClassName, }) => {
  return (
    <section className={`slide ${slideGroupClassName} what-is-reading-for-evidence-slide`} key="what-is-reading-for-evidence-slide">
      <h1>What is Reading for Evidence?</h1>
      <p>With Reading for Evidence, students build content knowledge and writing skills <b>concurrently</b>.<br />In Reading for Evidence activities, students:</p>
      <ol>
        <li className="evidence-step">
          <span className="step-number">1.</span>
          <p>Read a nonfiction text</p>
          <img alt="A paragraph from an Evidence activity, showing a highlighted sentence" src={EVIDENCE_HIGHLIGHT} />
        </li>
        <li className="evidence-step">
          <span className="step-number">2.</span>
          <p>Write sentences citing evidence</p>
          <img alt="A prompt from an Evidence activity, instructing the student to finish the sentence" src={EVIDENCE_STEP_FIRST_ATTEMPT} />
        </li>
        <li className="evidence-step">
          <span className="step-number">3.</span>
          <p>Revise based on feedback</p>
          <img alt="A submitted prompt from an Evidence activity with feedback on the student submission" src={EVIDENCE_STEP_WITH_FEEDBACK} />
        </li>
        <li>
          <img alt="" src={FOUNTAIN_PEN_ICON} />
          <p>This <b>write-and-revise</b> cycle repeats up to 5 times.</p>
        </li>
      </ol>
    </section>
  )
}

export default WhatIsReadingForEvidence
